// @flow
type valuesType = {
  password?: string,
  passwordConfirmation?: string
};

type errorsType = {
  password?: string,
  passwordConfirmation?: string
};

// Helper function to check if password meets all requirements
const meetsPasswordRequirements = (password: string): boolean => {
  return (
    password.length >= 8 &&
    /[a-z]/.test(password) &&
    /[A-Z]/.test(password) &&
    /[0-9]/.test(password) &&
    /[!@#$%^&*()_+-=[\]{};':"\\|,.<>/?]/.test(password)
  );
};

const validate = ({
  password,
  passwordConfirmation
}: valuesType): errorsType => {
  const errors = {};
  if (!password) {
    errors.password = 'Required';
  }

  if (!passwordConfirmation) {
    errors.passwordConfirmation = 'Required';
  }

  if (password && password.length < 8) {
    errors.password = 'Password must be at least eight characters long';
  }

  if (passwordConfirmation && passwordConfirmation.length < 8) {
    errors.passwordConfirmation =
      'Password must be at least eight characters long';
  }

  // Check for at least one lowercase character
  if (password && !/[a-z]/.test(password)) {
    errors.password = 'Password must contain at least one lowercase letter';
  }

  // Check for at least one uppercase character
  if (password && !/[A-Z]/.test(password)) {
    errors.password = 'Password must contain at least one uppercase letter';
  }

  // Check for at least one number
  if (password && !/[0-9]/.test(password)) {
    errors.password = 'Password must contain at least one number';
  }

  // Check for at least one special character
  if (password && !/[!@#$%^&*()_+-=[\]{};':"\\|,.<>/?]/.test(password)) {
    errors.password = 'Password must contain at least one special character';
  }

  if (password !== passwordConfirmation) {
    errors.passwordConfirmation = 'Passwords do not match!';
  }

  return errors;
};

export default validate;
export { meetsPasswordRequirements };
